<template>
  <div class="list-container">
    <div v-show="!dialogFormVisible">
      <div class="filter-container">
        <template v-if="!isFilterCollapse">
          <div class="filter-box">
            <span class="label">供应商</span>
            <el-input
              v-model="listQuery.name"
              style="width: 200px"
              :size="t('table.btnSize')"
              class="filter-item"
              clearable
              @keyup.enter="handleFilter"
            />
          </div>
          <!-- <div class="filter-box">
            <span class="label">公司座机</span>
            <el-input
              v-model="listQuery.contactNumber"
              style="width: 200px"
              :size="t('table.btnSize')"
              class="filter-item"
              clearable
              @keyup.enter="handleFilter"
            />
          </div>
          <div class="filter-box">
            <span class="label">联系人</span>
            <el-input
              v-model="listQuery.contactName"
              style="width: 200px"
              :size="t('table.btnSize')"
              class="filter-item"
              clearable
              @keyup.enter="handleFilter"
            />
          </div> -->
          <div class="filter-box">
            <span class="label">联系电话</span>
            <el-input
              v-model="listQuery.contactPhone"
              style="width: 200px"
              :size="t('table.btnSize')"
              class="filter-item"
              clearable
              @keyup.enter="handleFilter"
            />
          </div>
          <div class="filter-box">
            <span class="label">审批状态</span>
            <el-select :filterable="true" v-model="listQuery.changeStatus" class="filter-item" placeholder="" clearable :size="t('table.btnSize')" @change="handleFilter">
              <el-option
                v-for="item in ReviewStatusOption"
                :key="item.id"
                :label="item.mark"
                :value="item.id"
              />
            </el-select>
          </div>
        </template>
        <div class="filter-box">
          <el-button
            v-waves
            class="filter-item "
            type="primary"
            :size="t('table.btnSize')"
            @click="handleFilter"
          >
            {{ t("table.search") }}
          </el-button>
          <el-button
            v-permission="{ pkey: `${permissionName}_ADD` }"
            class="filter-item"
            type="primary"
            :size="t('table.btnSize')"
            @click="handleCommand('add')"
          >
            {{ t("table.add") }}
          </el-button>
          <el-button
            v-waves
            class="filter-item"
            :size="t('table.btnSize')"
            @click="handleReset"
          >
            {{ t("table.reset") }}
          </el-button>
          <el-button
            v-waves
            class="filter-item"
            :size="t('table.btnSize')"
            @click="isFilterCollapse = !isFilterCollapse"
          >
            {{isFilterCollapse ? '展开' : '收起'}}
          </el-button>
          <span class="svg-icon cursor mr-10 ml-10" @click="handleCommand('refresh')">
            <i class="icon-tubiao-27 iconfont"/>
          </span>
          <span class="svg-icon cursor" @click="handleCommand('column')">
            <i class="icon-tubiao-28 iconfont"/>
          </span>
        </div>
      </div>
      <div class="split-table-layout">
        <!-- 主表区域 -->
        <div
          class="split-pane-top vue-grid-item"
          :style="{ height: isSubMenuCollapse ? '100%' : `${topHeight}px` }"
        >
          <TableList
              :ref="rf => { if (rf) tableDataRef[0] = rf }"
              v-loading="listLoading"
              :dataList="list"
              :columnAllData="columnAllData"
              :tableName="TableName"
              :permissionName="permissionName"
              :showSelection="false"
              :isShowPagination="false"
              :handleDefaultWidth="120"
              :highlightCurrentRow="true"
              :layoutHeight="true"
              :newHpx="newHpx"
              :canRefresh="false"
              :canChangeColumn="false"
              style="height:calc(100% );overflow:hidden;"
              @row-click="handleRowClick"
              @command-change="handleCommand"
            >
              <template v-slot:name="scope">
                <span
                  :class="scope.row.changeStatus === 2 ? 'redStatusStyle' : scope.row.changeStatus === 1 ? 'yellowStatusStyle' : ''"
                  class="statusStyle">
                  <template v-if="scope.row.changeStatus && scope.row.changeStatus !== 3">
                    <i class="iconfont icon-tubiao-40"></i>
                    <span
                      class="status">{{ ReviewStatusOption.find(k => k.id === scope.row.changeStatus) ? ReviewStatusOption.find(k => k.id === scope.row.changeStatus).mark : '' }} </span>
                  </template>
                  <span :style="scope.row.status ? 'color:green' : 'color:red'">{{ scope.row.name }}</span>
                </span>
              </template>

              <template v-slot:operation-action="scope">
                <el-link
                  v-permission="{ pkey: `${permissionName}_EDIT` }"
                  href="javascript:void(0);"
                  class="mr-10"
                  type="primary"
                  @click="handleCommand('edit', scope.row)"
                >
                  {{ t("table.edit") }}
                </el-link>
              </template>
            </TableList>
            <el-pagination
              class="mt-20"
              v-show="total > 0"
              :total="total"
              v-model:currentPage="listQuery.page"
              :page-size="listQuery.size"
              :page-sizes="pageSizes"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              layout="total, sizes, prev, pager, next"
            />
        </div>

        <!-- 水平交互分割线 -->
        <TableSplitter
          v-if="!isSubMenuCollapse && tabList.length"
          @drag-start="handleSplitterDragStart"
          @drag-move="handleSplitterDragMove"
          @drag-end="handleSplitterDragEnd"
        />

        <!-- 子表区域 -->
        <div
          v-show="!isSubMenuCollapse && tabList.length"
          class="split-pane-bottom"
          :style="{ height: `${bottomHeight}px` }"
        >
          <div class="clearfix tab-title btn-container mt-10">
                <ul class="tab-title_left fl">
                  <li v-for="item in tabList" :key="item.id" :class="{ active: activeTab === item.id }" @click="handleTabClick(item)">{{item.name}}</li>
                </ul>
<!--                <div class="fr rigth-opt">-->
<!--                  <span class="svg-icon cursor mr-10" @click="handleTabCommand('refresh')">-->
<!--                    <i class="icon-tubiao-27 iconfont"/>-->
<!--                  </span>-->
<!--                        <span class="svg-icon cursor" @click="handleTabCommand('column')">-->
<!--                    <i class="icon-tubiao-28 iconfont"/>-->
<!--                  </span>-->
<!--                </div>-->
              </div>
              <ContactList v-if="activeTab === 1" ref="ContactList" :id="activeId"/>
              <AccountInfoList v-if="activeTab === 2" ref="AccountInfoList" :id="activeId"/>
              <TraceInfo v-if="activeTab === 3" ref="TraceInfo" :id="activeId" :api="'supplier'"/>
              <PriceInfo v-if="activeTab === 4" ref="PriceInfo" :id="activeId" formPage="supplier" :dataId="activeId"/>
        </div>
      </div>
    </div>
    <FormComponent
      v-if="dialogFormVisible"
      :id="activeId"
      :initFormData="initFormData"
      :fromFieldData="fromFieldData"
      :dialogFormVisible="dialogFormVisible"
      :handleResolveTempData="handleResolveTempData"
      :api="'supplier'"
      @update:visibel="() => dialogFormVisible = false"
      @submit="handleSubmit(formData)"
    />
    <el-button type="primary" circle @click="handleSubMenuCollapse" class="subMenuCollapseBtn" v-if="!dialogFormVisible"> {{isSubMenuCollapse ? '展开' : '收起'}}</el-button>
  </div>
</template>

<script lang='ts'>
import TableSplitter from '@/components/common/TableSplitter.vue'
import { useTableSplitter } from '@/composables/useTableSplitter'
import { useStore } from '@/store'
import { defineComponent, reactive, toRefs, onMounted, ref, nextTick, watch } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { cloneDeep } from 'lodash'
import { getCompanyDetailById, deleteCompanyById, getCompanyList } from '@/apis/Supplier'
import { getDropdown } from '@/apis/Dictionary'
import { getPageList } from '@/apis/Form'
import { getDropdownByType } from '@/apis/tool'

import { CostModel, ArrayRowsItem } from '@/model/Index'

import FormComponent from '@/components/Form/index.vue'
import TableList from '@/components/common/TableList.vue'
import ContactList from './contact/Index.vue'
import AccountInfoList from './accountInfo/Index.vue'
import TraceInfo from '@/components/traceInfo/Index.vue'
import PriceInfo from '@/views/purchasManage/purchaseInAdvance/priceInfo/Index.vue'
import { TableName, permissionName } from '@/utils/enum'
import { FromFieldData } from './FieldFrom'
import { TableField } from './FieldTable'
import { pageVo, pageSizes } from '@/utils/index'

import { useI18n } from 'vue-i18n'
import mixin from '@/mixins'

export default defineComponent({
  name: 'Supplier',
  components: {
    TableSplitter,
    FormComponent,
    TableList,
    ContactList,
    AccountInfoList,
    TraceInfo,
    PriceInfo
  },
  setup() {
    const { t } = useI18n()
    const store = useStore()
    const userId = store.state.user.userId
    const ContactList = ref(null)
    const AccountInfoList = ref(null)
    const TraceInfo = ref(null)
    const tableDataRef = ref([])
    const PriceInfo = ref(null)

    const dataMap = reactive({
      TableName: TableName.TABLE_SUPPLIER,
      permissionName: permissionName.SUPPLIER,
      initFormData: cloneDeep(FromFieldData),
      fromFieldData: FromFieldData,
      columnAllData: TableField,

      activeId: 0,
      list: [],
      total: 0,
      listLoading: false,
      listQuery: {
        name: undefined,
        contactNumber: undefined,
        contactName: undefined,
        contactPhone: undefined,
        changeStatus: undefined,
        ...pageVo
      },
      pageSizes,
      dialogFormVisible: false,

      tabList: [
        { name: '联系人', id: 1 }
        // { name: '付款信息', id: 2 },
        // { name: '价格信息', id: 4 },
        // { name: '跟踪信息', id: 3 }
      ],
      activeTab: 1,

      customerLevelOption: [],
      customerSourceOption: [],
      paymentCycleOption: [],
      ReviewStatusOption: [],
      salesManId: '',
      fpVisible: false,
      newHpx: 0,
      handleCommand(command: string, val?: any) {
        switch (command) {
          case 'add':
            dataMap.handleCreate()
            break
          case 'fp':// 分配
            dataMap.salesManId = val.salesManId
            dataMap.activeId = val.id
            dataMap.fpVisible = true
            break
          case 'edit':
            dataMap.handleUpdate(val)
            break
          case 'delete':
            dataMap.handleDelete(val)
            break
          case 'refresh':
            dataMap.handleFilter()
            break
          case 'column':
            (tableDataRef.value[0] as any).setColumnVisible = true
            break
          case 'current-change':
            dataMap.handleCurrentChange(val)
            break
          case 'size-change':
            dataMap.handleSizeChange(val)
            break
        }
      },
      handleRowClick(row: any) {
        dataMap.activeId = row.id
      },
      calcHeight() {
        return 'calc(100% - 50px)'
      },
      handleTabCommand(command: string) {
        if (this.activeTab === 1) {
          if (ContactList.value && ContactList.value) {
            ;(ContactList.value as any).handleCommand(command)
          }
        } else if (this.activeTab === 2) {
          if (AccountInfoList.value && AccountInfoList.value) {
            ;(AccountInfoList.value as any).handleCommand(command)
          }
        } else if (this.activeTab === 3) {
          if (TraceInfo.value && TraceInfo.value) {
            ;(TraceInfo.value as any).handleCommand(command)
          }
        } else if (this.activeTab === 4) {
          if (PriceInfo.value && PriceInfo.value) {
            ;(PriceInfo.value as any).handleCommand(command)
          }
        }
      },
      getList() {
        dataMap.listLoading = true
        getCompanyList(dataMap.listQuery).then((res: any) => {
          dataMap.list = res.data || []
          dataMap.total = res.total
          dataMap.listLoading = false
          dataMap.activeId = dataMap.list.length ? dataMap.list[0].id : 0
        }).catch(() => {
          dataMap.listLoading = false
        })
      },
      handleReset() {
        dataMap.listQuery = {
          name: undefined,
          contactNumber: undefined,
          contactName: undefined,
          contactPhone: undefined,
          changeStatus: undefined,
          ...pageVo
        }
        dataMap.handleFilter()
      },
      handleFilter() {
        dataMap.getList()
      },

      handleCreate() {
        dataMap.activeId = 0
        dataMap.fromFieldData = cloneDeep(dataMap.initFormData)
        dataMap.dialogFormVisible = true
      },
      handleUpdate(row: any) {
        dataMap.activeId = row.id
        dataMap.fromFieldData = cloneDeep(dataMap.initFormData)

        getCompanyDetailById(row.id).then((res: any) => {
          dataMap.fromFieldData.forEach((k: any) => {
            if (k.type === 1) {
              k.formList.forEach((field: any) => {
                field.value = res[field.fieldKey] || field.value
                switch (field.fieldKey) {
                  case 'address':
                    field.value = res.address ? res.address.split('-') : ''
                    break
                }
              })
            } else if (k.type === 2) {
              const _arr = [] as ArrayRowsItem
              const addContions = dataMap.initFormData.find((j: any) => j.title === '账户信息')?.formList
              if (addContions) {
                res.accounts.forEach((item: any) => {
                  const _copyContion = cloneDeep(addContions)[0]
                  _copyContion.id = item.id
                  Object.keys(item).forEach(k => {
                    _copyContion.list?.forEach((j: any) => {
                      if (j.fieldKey === k) {
                        j.value = item[k] || j.value
                      }
                    })
                  })
                  _arr.push(_copyContion)
                })
                k.formList = _arr
              }
            }
          })
          // dataMap.fromFieldData = dataMap.fromFieldData.filter((k: any) => k.type === 1)
          dataMap.dialogFormVisible = true
        })
      },
      handleResolveTempData(tempModel: any) {
        const { address } = tempModel
        let contacts = tempModel.contacts
        if (contacts) {
          contacts.map((k: any) => {
            k.address = address ? address.join('-') : ''
            return {
              ...k
            }
          })
        } else {
          contacts = []
        }
        tempModel.address = address ? address.join('-') : ''
      },
      handleDelete(row: any) {
        ElMessageBox.confirm(
          '确定要删除选中数据吗？',
          '删除',
          {
            confirmButtonText: t('table.confirm'),
            cancelButtonText: t('table.cancel'),
            type: 'warning',
            cancelButtonClass: 'el-button--danger'
          }
        )
          .then(() => {
            deleteCompanyById(row.id).then(() => {
              dataMap.getList()
              ElMessage({
                message: '删除成功',
                type: 'success',
                duration: 1000
              })
            })
          })
      },
      handleSubmit() {
        dataMap.getList()
      },
      handleCurrentChange(page?: any) {
        dataMap.listQuery.page = page
        dataMap.getList()
      },
      handleSizeChange(size: any) {
        dataMap.listQuery.size = size
        dataMap.handleCurrentChange(1)
      },
      loadDropdownList(url: string) {
        getDropdown(url).then((res: any) => {
          dataMap[`${url}Option`] = res
        })
      },
      getDropdownByType() {
        getDropdownByType('ReviewStatus').then((res: any) => {
          dataMap.ReviewStatusOption = res
        })
      },
      loadTableSelectOption() {
        dataMap.columnAllData.forEach((column: any) => {
          if (column.selectType === 2 && column.url) {
            getPageList(column.url).then((res: any) => {
              column.option = res
                ? res.map((k: any) => {
                  return {
                    ...k,
                    name: k.mark
                  }
                })
                : []
            })
          } else if (column.selectType === 1 && column.url) {
            getDropdownByType(column.url).then((res: any) => {
              column.option = res
                ? res.map((k: any) => {
                  return {
                    ...k,
                    name: k.mark
                  }
                })
                : []
            })
          }
        })
      },
      handleTabClick(item: any) {
        dataMap.activeTab = item.id
      },
      handleSetColumnVisible() {
        nextTick(() => {
          console.log(TableList.value, 'tableList.value')
        })

        if (TableList.value && TableList.value) {
          ;(TableList.value as any).setColumnVisible = true
        }
      },
      handleResizedEvent(i: any, newH: any, newW: any, newHPx: any) {
        dataMap.newHpx = newHPx
      }
    })
    const { mixinData } = mixin(dataMap)

    const splitter = useTableSplitter({
      storageKey: 'erp.split_ratio./supplier/Index',
      defaultRatio: 0.38,
      minTopHeight: 140,
      minBottomHeight: 0,
      splitterHeight: 22,
      paginationHeight: 52,
      onResize: (topH) => {
        dataMap.newHpx = topH
      }
    })

    watch(() => mixinData.isFilterCollapse, () => {
      setTimeout(() => {
        splitter.applyLayout()
      }, 50)
    })
    onMounted(async() => {
      mixinData.initHeight()

      await dataMap.loadTableSelectOption()
      dataMap.getList()
      // dataMap.loadDropdownList('customerLevel')
      // dataMap.loadDropdownList('customerSource')
      // dataMap.loadDropdownList('paymentCycle')
      dataMap.getDropdownByType()
    })
    return { ContactList, AccountInfoList, TraceInfo, tableDataRef, t, ...toRefs(dataMap), ...toRefs(mixinData),
      ...splitter,
      handleSubMenuCollapse: splitter.toggleSubMenuCollapse, userId }
  }
})
</script>
<style lang="scss">
.grid-layout-container {
  .vue-grid-item {
    background: #666;
  }
}
</style>
<style lang="scss" scope>
.statusStyle {
  .status {
    // border: 1px solid;
    padding: 0 4px;
    border-radius: 6px;
    margin-right: 7px;
    font-size: 10px;
    color: #fff;
  }
}

.redStatusStyle {
  .icon-tubiao-40 {
    color: #E74228;
  }

  .status {
    background-color: #E74228;
  }
}

.yellowStatusStyle {
  .icon-tubiao-40 {
    color: #F3D03C;
  }

  .status {
    background-color: #F3D03C;
  }
}

.warming-fp {
  border-radius: 4px;
  border: 1px solid $red;
  color: $red;
  padding: 8px;
  margin-bottom: 20px;
}
</style>
